import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              About Fun Affairs
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto">
              The Lehigh Valley's trusted event entertainment rental company for over 15 years.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                  Our Story
                </h2>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Fun Affairs has been making celebrations unforgettable in the Lehigh Valley for over 15 years. What started as a small party rental business has grown into the region's premier event entertainment company, serving thousands of satisfied customers throughout Allentown, Bethlehem, Easton, and surrounding Pennsylvania communities.
                </p>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Our commitment to quality, safety, and exceptional customer service has made us the trusted choice for birthday parties, corporate events, school functions, festivals, and community gatherings of all sizes. We take pride in being a locally owned and operated business that truly cares about our community.
                </p>
                <p className="text-base text-gray-600 leading-relaxed">
                  Every member of our team is dedicated to making your event perfect. From our friendly customer service staff to our professional delivery and setup crew, we go above and beyond to ensure your celebration is stress-free and memorable.
                </p>
              </div>
              <div className="relative">
                <img 
                  src="https://funaffairs.com/wp-content/uploads/2022/11/fun-affairs.png"
                  alt="Fun Affairs Team"
                  className="w-full rounded-2xl shadow-2xl"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
              <div className="text-center p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200">
                <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-2xl mx-auto mb-6">
                  <i className="ri-calendar-check-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-4xl font-bold text-gray-900 mb-2">15+</h3>
                <p className="text-base text-gray-600">Years in Business</p>
              </div>
              <div className="text-center p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200">
                <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-2xl mx-auto mb-6">
                  <i className="ri-emotion-happy-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-4xl font-bold text-gray-900 mb-2">5000+</h3>
                <p className="text-base text-gray-600">Events Completed</p>
              </div>
              <div className="text-center p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200">
                <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-2xl mx-auto mb-6">
                  <i className="ri-star-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-4xl font-bold text-gray-900 mb-2">5.0</h3>
                <p className="text-base text-gray-600">Average Rating</p>
              </div>
            </div>

            <div className="mb-24">
              <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
                Our Core Values
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="p-8 bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-shield-check-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Safety First</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Every piece of equipment is professionally cleaned, sanitized, and safety-inspected before each rental. We maintain the highest safety standards and are fully licensed and insured.
                  </p>
                </div>
                <div className="p-8 bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-customer-service-2-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Exceptional Service</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    We treat every customer like family. Our friendly, professional staff is dedicated to making your event perfect from the first phone call to final pickup.
                  </p>
                </div>
                <div className="p-8 bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-heart-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Community Focused</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    As a locally owned business, we're proud to serve our Lehigh Valley community. We support local schools, charities, and community events.
                  </p>
                </div>
                <div className="p-8 bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-price-tag-3-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Fair Pricing</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    We believe in transparent, honest pricing with no hidden fees. You get premium quality equipment and service at competitive rates.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white p-12 rounded-2xl border border-gray-200">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
                Why Choose Fun Affairs?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-base text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Extensive Inventory</h4>
                    <p className="text-sm text-gray-600">Wide selection of entertainment options for all event types and sizes</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-base text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Professional Setup</h4>
                    <p className="text-sm text-gray-600">Experienced crew handles delivery, setup, and pickup</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-base text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">On-Time Delivery</h4>
                    <p className="text-sm text-gray-600">We respect your schedule and arrive when promised</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-base text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Clean Equipment</h4>
                    <p className="text-sm text-gray-600">Professionally cleaned and sanitized before every rental</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-base text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Licensed & Insured</h4>
                    <p className="text-sm text-gray-600">Fully licensed and insured for your peace of mind</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-base text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Local Expertise</h4>
                    <p className="text-sm text-gray-600">Deep knowledge of Lehigh Valley venues and events</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Let's Make Your Event Amazing
            </h2>
            <p className="text-xl text-white/95 mb-8">
              Contact Fun Affairs today and experience the difference that 15+ years of expertise makes.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link 
                to="/contact" 
                className="bg-white text-red-600 px-8 py-4 rounded-full text-base font-bold hover:bg-gray-100 transition-colors whitespace-nowrap w-full sm:w-auto"
              >
                Get Free Quote
              </Link>
              <a 
                href="tel:6102532835" 
                className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
              >
                <i className="ri-phone-fill mr-2"></i>
                (610) 253-2835
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}